// import { useState } from "react";
import { Link } from "react-router-dom";
import { GetContratos } from "../../actions/contrato.jsx";
import { GotoLogin } from "../../actions/renovarLog";
import style from "../../styles/grid.module.css";
import { useMutation } from "@tanstack/react-query";
// import { FcDeleteRow,FcAbout  } from "react-icons/fc";
import { Pencil, SquareX, CirclePlus } from "lucide-react";

export default function Contratosp() {
   const token = localStorage.getItem("token");
   const url = process.env.REACT_APP_URL_DIR + "cliente";

   const data = GetContratos();

   const { mutate } = useMutation({
      mutationFn: (id) =>
         fetch(url + "/" + id, {
            method: "DELETE",
            body: JSON.stringify(),
            headers: {
               Authorization: `Bearer ${token}`,
               "Content-Type": "application/json",
            },
         }).then((res) => res.json()),
      onSuccess: (res) => {
         if (res?.message) {
            alert(`Aviso : ${res.message}`);
         }
         window.location.href = "/clientes";
      },
      onError: () => {
         alert("Error");
      },
   });

   // function handleInputChange(e) {
   //    if (e.key === "Enter") {
   //       // dispatch(GetContratosByName(usr, nombre));
   //       console.log('clientes: ', nombre);
   //       setName("");
   //    }
   // }

   const handleRemove = (id) => {
      let text =
         "Se va a eliminar el Cliente selecionado!\nSelecione Aceptar or Cancelar.";
      if (window.confirm(text) === true) {
         mutate(id);
      }
   };

   if (data?.message === "Token inválido") {
      return <GotoLogin />;
   }

   console.log("data: ", data);
   return (
      <div className={style.tableCli}>
         <div>
            <div>
               <div className={style.gridTitle}>
                  <h2>Contratos de Piercing</h2>
               </div>
            </div>
            <div>
               <div>
                  <Link
                     to={"/Contratopiercing"}
                     className="dLink"
                     title="Alta Contrato Piercing"
                     state={{
                        id: 0,
                     }}
                  >
                     {" "}
                     <CirclePlus className="lucidePlus" />
                     {/* <button className={style.inputBtnNew}>Alta Cliente</button> */}
                  </Link>
                  &nbsp;&nbsp;
               </div>
            </div>
         </div>
         <br />
         <div>
            <table className={style.gridTable}>
               <thead>
                  <tr style={{ background: "#eee" }}>
                     <th style={{ border: "1px solid #ccc", padding: "8px" }}>
                        ID
                     </th>
                     <th style={{ border: "1px solid #ccc", padding: "8px" }}>
                        Documento
                     </th>
                     <th style={{ border: "1px solid #ccc", padding: "8px" }}>
                        Nombre
                     </th>
                     <th style={{ border: "1px solid #ccc", padding: "8px" }}>
                        Accion
                     </th>
                  </tr>
               </thead>
               <tbody>
                  {data?.length > 0 &&
                     data?.map((contrato) => {
                        return (
                           <tr key={contrato.id}>
                              <td
                                 style={{
                                    border: "1px solid #ccc",
                                    padding: "8px",
                                 }}
                              >
                                 {contrato.id}
                              </td>
                              <td
                                 style={{
                                    border: "1px solid #ccc",
                                    padding: "8px",
                                 }}
                              >
                                 {contrato.cliente[0]}
                              </td>
                              <td
                                 style={{
                                    border: "1px solid #ccc",
                                    padding: "8px",
                                 }}
                              >
                                 {contrato.cliente[1]}
                              </td>
                              <td
                                 style={{
                                    border: "1px solid #ccc",
                                    padding: "8px",
                                 }}
                              >
                                 <Link
                                    title="Ver Contrato"
                                    to={"/Contratopiercing"}
                                    state={{
                                       id: contrato.cliente[0],
                                    }}
                                 >
                                    <Pencil className="lucideIcon" />
                                 </Link>
                                 &nbsp;&nbsp;
                                 <span
                                    className="lucideIconDel"
                                    title="Eliminar Contrato"
                                 >
                                    <SquareX
                                       className="lucideIconDel"
                                       onClick={() => handleRemove(contrato.id)}
                                    />
                                 </span>
                              </td>
                           </tr>
                        );
                     })}
               </tbody>
            </table>
         </div>
      </div>
   );
}
